import "../assets/Common.scss";
import "../assets/fonts/font.css";
import React, { useEffect } from "react";

import {
  moveToLogin,
  trackEvent,
  getInsetTop,
  calc,
  getChipsUid,
} from "../js/chips-common.js";

import IcBack from "../vending-machine/assets/ic-back.png";
import reloadForChecksum from "../util/ReloadChecksum";
import chipsApi from "../js/chips-api";
import { encryptText } from "../util/JSEncrypt";
import { share } from "../util/Sharer";

export default function Referral(props) {
  const dev = props.dev;
  const domain = dev
    ? `https://api.${dev}.chips.today`
    : "https://api.chips.today";

  const definedReferralType = "tycoon_invitation_referral_vending_machine";
  const pageTitle = "하트 자판기";

  const visibilityChange = () => {
    if (!document.hidden) {
      // 페이지가 트랜지션 과정에서 active 상태로 잡히는 경우가 있어서
      // 500ms 이후 페이지가 active 상태인 경우에만 새로고침 함
      setTimeout(() => {
        if (!document.hidden) {
          refresh();
        }
      }, 500);
      refresh();
    }
  };

  const [availableInstallCount, setAvailableInstallCount] = React.useState(0);

  function refresh() {
    try {
      if (getChipsUid()) {
        // eslint-disable-next-line no-undef
        chipsApi.request({
          method: "get",
          url: `${domain}/api/v1/tycoon/user/vending-machine/heart-referral`,
          then: (response) => {
            const data = response.data;
            // eslint-disable-next-line no-undef
            const count = data.install_opportunity_count;
            setAvailableInstallCount(count);
          },
        });
      }
    } catch (e) {}
  }
  function showLoginBottomSheet() {
    trackEvent("login_required");

    const attributes = {
      icon: "https://cdn.chips.today/logic/barcode/zips/2024/03/18/1710756901611-0bbd476e-3c68-4a11-8500-7d2ee5f24624.png",
      title: "로그인/회원가입을 해주세요!",
      body: "로그인하고 칩스를 시작하세요.<br>지금 가입하면 신규 회원 혜택 600원까지!",
      secondary_button_text: "취소",
      primary_button_text: "시작하기",
      primary_button_callback: "moveToLogin()",
    };
    try {
      // eslint-disable-next-line no-undef
      chipsApp.showLoginBottomSheet(JSON.stringify(attributes));
    } catch (e) {}
  }

  function installHeartVendingMachine() {
    if (getChipsUid()) {
      if (availableInstallCount === 0) {
        try {
          // eslint-disable-next-line no-undef
          chipsApp.showToast("초대한 친구가 가입해야 설치할 수 있어요. 🥹");
        } catch (e) {
          alert("초대한 친구가 가입해야 설치할 수 있어요. 🥹");
        }
        return;
      }
      // eslint-disable-next-line no-undef
      chipsApi.request({
        method: "post",
        url: `${domain}/api/v1/tycoon/user/vending-machine/heart-referral`,
        then: (response) => {
          // eslint-disable-next-line no-undef
          chipsApp.close();
        },
      });
    } else {
      showLoginBottomSheet();
    }
  }

  function getDeepLinkUrl() {
    var uid = getChipsUid();
    var type = definedReferralType;
    var deeplink = encodeURIComponent(
      "chips://benefit_plus/tycoon?referral_uid=" +
        uid +
        "&referral_type=" +
        type,
    );
    return deeplink;
  }

  function copyText(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    Object.assign(textArea.style, { position: "fixed", top: 0 });
    Object.assign(textArea, { contentEditable: true, readOnly: true });

    document.body.appendChild(textArea);
    textArea.focus();

    const range = document.createRange();
    range.selectNodeContents(textArea);

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    textArea.setSelectionRange(0, 999999);

    document.execCommand("copy");
    document.body.removeChild(textArea);
  }

  function copyLink() {
    if (getChipsUid()) {
      trackEvent("copy_link");
      try {
        // eslint-disable-next-line no-undef
        const referralUid = getChipsUid();
        const deeplink = `chips://benefit_plus/tycoon?referral_uid=${referralUid}&referral_type=${definedReferralType}`;
        const encodedDeeplink = encodeURIComponent(deeplink);
        const androidUrl = `https://market.android.com/details?id=today.chips&url=${encodedDeeplink}`;
        const encodedAndroidUrl = encodeURIComponent(androidUrl);
        const link = `https://link.chips.today/dr0y4i?deeplink_url=${encodedDeeplink}&fallback_android=${encodedAndroidUrl}`;

        copyText(link);
        // eslint-disable-next-line no-undef
        chipsApp.showToast("🙌 칩스 초대링크가 복사되었어요.");
      } catch (e) {}
    } else {
      showLoginBottomSheet();
    }
  }

  function shareKakao() {
    try {
      if (getChipsUid()) {
        trackEvent("share");
        // eslint-disable-next-line no-undef
        const user = JSON.parse(chipsApp.getUserInfo());
        const userIdEnc = encryptText(user.id.toString());

        // eslint-disable-next-line no-undef
        const referralUid = getChipsUid();
        const deeplink = `chips://benefit_plus/tycoon?referral_uid=${referralUid}&referral_type=${definedReferralType}`;
        const encodedDeeplink = encodeURIComponent(deeplink);
        const androidUrl = `https://market.android.com/details?id=today.chips&url=${encodedDeeplink}`;
        const encodedAndroidUrl = encodeURIComponent(androidUrl);

        // eslint-disable-next-line no-undef
        Kakao.Share.sendCustom({
          templateId: 107743,
          templateArgs: {
            referral_uid: referralUid,
            referral_type: definedReferralType,
            deferred: encodeURIComponent(encodedAndroidUrl),
            deeplink: encodedDeeplink,
          },
          serverCallbackArgs: {
            user_id_enc: userIdEnc,
          },
        });
      } else {
        // eslint-disable-next-line no-undef
        showLoginBottomSheet();
      }
    } catch (e) {}
  }

  useEffect(() => {
    window.moveToLogin = moveToLogin;
    document.removeEventListener("visibilitychange", visibilityChange);
    document.addEventListener("visibilitychange", visibilityChange);
    document.title = pageTitle;

    try {
      // eslint-disable-next-line no-undef
      chipsApp.setThemeColor("#FFFFFF");

      // eslint-disable-next-line no-undef
      chipsApp.showHeader(true);

      // eslint-disable-next-line no-undef
      chipsApp.setFullscreen(false);
    } catch (e) {}

    refresh();
    reloadForChecksum();

    // Kakao SDK 로딩
    new Promise((onload, reject) => {
      const src = "https://t1.kakaocdn.net/kakao_js_sdk/2.1.0/kakao.min.js";
      const integrity =
        "sha384-dpu02ieKC6NUeKFoGMOKz6102CLEWi9+5RQjWSV0ikYSFFd8M3Wp2reIcquJOemx";
      const crossOrigin = "anonymous";
      const script = document.createElement("script");
      script.integrity = integrity;
      script.crossOrigin = crossOrigin;
      const onerror = (evt) =>
        reject(URIError(`스크립트 로딩 실패 ${evt.target.src}`));
      Object.assign(script, { type: "text/javascript", onload, onerror, src });
      document.head.appendChild(script);
    }).then(() => window.Kakao.init("e70756f39b9983141207090ae7dac505"));
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#8535fe",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <div
        className="scrollbar-hidden"
        style={{
          background: "transparent",
          position: "absolute",
          overflowY: "scroll",
          overflowX: "hidden",
          bottom: 0,
          top: 0,
          left: 0,
          right: 0,
        }}
      >
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: calc(30),
            alignItems: "center",
          }}
        >
          <div
            style={{
              color: `rgba(255, 255, 255, 0.8)`,
              fontSize: calc(16),
              fontFamily: "SUITE",
              fontWeight: 400,
            }}
          >
            친구 초대하고
          </div>
          <div
            style={{
              textAlign: "center",
              marginTop: calc(8),
              color: "white",
              fontSize: calc(34),
              fontFamily: "SUITE",
              fontWeight: 900,
              lineHeight: calc(44),
            }}
          >
            보석 나오는
            <br />
            자판기 설치하기
          </div>

          {/* <div style={{ display: "flex", justifyContent: "center" }}> 
          <img
            style={{
              marginTop: calc(20),
              width: calc(204),
              height: calc(227),
            }}
            src="https://cdn.chips.today/logic/images/2024/05/23/1716464791943-56d847cd-8b56-40dd-bf7f-7d5f304e6d06.png"
            />
            </div> */}
            <img
              style={{
                marginTop: calc(20),
                width: calc(204),
                height: calc(227),
              }}
            src="https://cdn.chips.today/logic/images/2024/05/23/1716464791943-56d847cd-8b56-40dd-bf7f-7d5f304e6d06.png"
            alt="heart"
            />
        </div>
        <div
          style={{
            
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: `${calc(12)} ${calc(12)} ${calc(12)} ${calc(12)}`,
            width: calc(320),
            height: calc(44),
            backgroundColor: `#6023e3`,
            flexDirection: "row",
            marginLeft: calc(20),
            marginRight: calc(20),
          }}
        >
          <div
            style={{
              color: "white",
              fontSize: calc(14),
              fontFamily: "OneMobilePop",

              textAlign: "center",
              marginLeft: `${calc(20)}`,
            }}
          >
            나의 설치권
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              alignItems: "center",
              flexDirection: "row",
              gap: calc(4),
              marginRight: calc(20),
              height: calc(44),
            }}
          >
            <span
              style={{
                fontSize: calc(14),
                fontFamily: "Spoqa Han Sans Neo",
                fontWeight: 700,
                color: "#ffffff",
              }}
            >
              {availableInstallCount}/3
            </span>
            <span
              style={{
                fontSize: calc(14),
                fontFamily: "Spoqa Han Sans Neo",
                fontWeight: 400,
                color: "#ffffff",
              }}
            >
              개
            </span>
          </div>
        </div>

        <div
          style={{
            marginTop: calc(12),
            display: "flex",
            flexDirection: "column",
            backgroundColor: `#FFFFFF`,
            borderRadius: `${calc(12)} ${calc(12)} ${calc(12)} ${calc(12)}`,
            marginLeft: `${calc(20)}`,
            marginRight: `${calc(20)}`,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: calc(320),
              height: calc(24),
              marginTop: calc(12),
              flexDirection: "row",
            }}
          >
            <div
              style={{
                color: "black",
                fontSize: calc(16),
                fontFamily: "OneMobilePop",
                textAlign: "center",
                marginLeft: `${calc(16)}`,
              }}
            >
              하트 자판기
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                marginRight: `${calc(16)}`,
              }}
            >
              <img
                src="https://cdn.chips.today/logic/images/2024/05/09/1715239878051-e57d8761-4683-4e2d-ba0f-337e8df99c97.png"
                style={{
                  width: calc(24),
                  height: calc(24),
                }}
                alt="heart"
              />
              <div
                style={{
                  width: calc(40),
                  textAlign: "center",
                  fontFamily: "OneMobilePop",
                  color: "#888888",
                  fontSize: calc(14),
                }}
              >
                30개
              </div>
              <img
                src="https://cdn.chips.today/logic/images/2024/05/09/1715239942187-161a2122-4bf4-40f7-90ea-31a21ed2a61c.png"
                style={{
                  width: calc(24),
                  height: calc(24),
                }}
                alt="heart"
              />
              <div
                style={{
                  width: calc(40),
                  textAlign: "center",
                  fontFamily: "OneMobilePop",
                  color: "#888888",
                  fontSize: calc(14),
                }}
              >
                120분
              </div>
            </div>
          </div>

          <div
            style={{
              marginTop: calc(8),
              width: "100%",
              padding: `0 ${calc(16)}`,
              boxSizing: "border-box",
              fontSize: calc(12),
              fontFamily: "Spoqa Han Sans Neo",
              fontWeight: 400,
              display: "flex",
              alignItems: "start",
              height: calc(14),
              color: "#212121",
              opacity: 0.7,
            }}
          >
            보석을 얻을 수 있는 하트 자판기는 일주일 동안 유지돼요
          </div>

          <div
            className="active-large"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: `${calc(12)} ${calc(12)} ${calc(12)} ${calc(12)}`,
              height: calc(44),
              width: `calc(100% - ${calc(32)})`,
              marginLeft: "auto",
              marginRight: "auto",
              padding: `${calc(12)} ${calc(16)}`,
              boxSizing: "border-box",
              marginTop: calc(20),
              marginBottom: calc(12),
              backgroundColor: `#3DC800`,
              color: "#ffffff",
              fontSize: calc(14),
              fontFamily: "OneMobilePop",
              textAlign: "center",
            }}
            onClick={() => {
              installHeartVendingMachine();
            }}
          >
            설치하기
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: '100%',
            boxSizing: "border-box",
            backgroundColor: `transparent`,
            marginTop: calc(30),
            padding: `0 ${calc(20)}`,
          }}
        >
          <img
            style={{
              width: `100%`,
            }}
            src="https://cdn.chips.today/logic/images/2024/05/09/1715243259763-1bd6a245-07ab-45e9-9c72-6d470bcb4115.png"
            alt="heart"
          />
          <div
            className="active-large"
            style={{
              borderRadius: `${calc(12)} ${calc(12)} ${calc(12)} ${calc(12)}`,
              height: calc(50),
              width: '100%',
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: calc(20),
              backgroundColor: `#FDE500`,
              gap: calc(6),
              padding: `${calc(12)} ${calc(16)}`,
              boxSizing: "border-box",
            }}
            onClick={() => {
              shareKakao();
            }}
          >
            <div
              style={{
                textColor: "#FFFFFF",
                fontSize: calc(14),
                fontWeight: 400,
                fontFamily: "Spoqa Han Sans Neo",
                textAlign: "center",
                color: "#212121",
              }}
            >
              카카오톡으로 초대하기
            </div>
            <div
              style={{
                justifyContent: "center",
              }}
            >
              <img
                style={{
                  width: calc(18),
                  height: calc(16),
                }}
                src="https://cdn.chips.today/logic/images/2024/05/09/1715248526735-7f8dc98d-cb12-41f0-b384-ca01acecc341.png"
                alt="kakao"
              />
            </div>
          </div>
          <div
            className="active-large"
            style={{
              borderRadius: `${calc(12)} ${calc(12)} ${calc(12)} ${calc(12)}`,
              height: calc(50),
              width: '100%',
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: `${calc(12)} ${calc(16)}`,
              boxSizing: "border-box",
              alignContent: "center",
              backgroundColor: `#EFEFEF`,
              marginTop: calc(10),
            }}
            onClick={() => {
              copyLink();
            }}
          >
            <div
              style={{
                textColor: "#FFFFFF",
                fontWeight: 400,
                fontSize: calc(14),
                fontFamily: "Spoqa Han Sans Neo",
                textAlign: "center",
                color: "#212121",
              }}
            >
              초대 링크 복사하기
            </div>
          </div>
        </div>

        <div
          style={{
            marginTop: calc(30),
            width: calc(360),
            backgroundColor: "#6023e3",
          }}
        >
          <img
            style={{
              width: `100%`,
            }}
            src="https://cdn.chips.today/logic/images/2024/05/09/1715235665100-46385a63-868f-48c9-91b5-805edfda5edb.png"
            alt="heart"
          />
        </div>
      </div>
    </div>
  );
}
